import axios from 'axios'
import { Message } from 'element-ui'
import { i18n } from '../i18n/index'
const baseURL = process.env.VUE_APP_API_BASE_URL
// const baseURL = 'http://zstp-api-test.tripitakas.net:18001'
// const refreshUrl = process.env.NODE_ENV === 'production' ? 'https://api-reader-test.tripitakas.net' : '/api'
// let refreshTokenLoading = false
const service = axios.create({
  baseURL: baseURL, // 生产打包环境
  // baseURL: '/api', // 本地测试
  withCredentials: true,
  timeout: 1000 * 60
})
export function getCookie (name) {
  const matches = document.cookie.match(new RegExp(
    '(?:^|; )' + name.replace(/([.$?*|{}()[]\/\+^])/g, '\\$1') + '=([^;]*)'
  ))
  return matches ? decodeURIComponent(matches[1]) : undefined
}
service.interceptors.request.use(
  config => {
    const token = getCookie('refreshToken')
    if (token) {
      config.headers.token = token
    }
    // 转为简体
    const converter = window.OpenCC.Converter({
      from: 'tw',
      to: 'cn'
    })
    if (config.data) {
      config.data = JSON.parse(converter(JSON.stringify(config.data)))
    }
    if (config.params) {
      config.params = JSON.parse(converter(JSON.stringify(config.params)))
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if ([400, 401, 403, 404, 500, 501].includes(res.code)) {
      if (res.code === 401 || res.code === 500 || res.code === 402) {
        // get_user_info 接口返回 401 表示未登录，需正常返回给调用方处理弹窗逻辑
        if (response.config.url === '/zstp/neo4j/get_user_info/') {
          return res
        }
        // 其他接口收到 401 不做任何反馈，静默返回
        return res
        // refreshToken
        // if (refreshTokenLoading) {
        // }
        // refreshTokenLoading = true
        // axios.get(refreshUrl + '/v1/refresh_token').then((res) => {
        //   const result = res.data
        //   if (result.code === 0) {
        //     document.cookie = `refreshToken=${result.result.access_token}`
        //     window.location.reload()
        //   } else {
        //     Message.error(res.message)
        //     return Promise.reject(res)
        //   }
        // }).catch(() => {
        //   Message.error(res.message)
        //   return Promise.reject(res)
        // }).finally(() => {
        //   refreshTokenLoading = false
        // })
      } else {
        if (['/zstp/neo4j/person_relation/'].includes(response.config.url)) {
          return res
        }
        Message.error(res.message || res.msg)
        return Promise.reject(res)
      }
    } else {
      if (response.config.responseType === 'blob') {
        return res
      }
      // if ([
      //   '/zstp/neo4j/person_category/',
      //   '/zstp/neo4j/get_name_search/',
      //   '/zstp/neo4j/biographie_name/',
      //   '/zstp/neo4j/get_all_sect/',
      //   '/zstp/neo4j/get_all_dynasty/'
      // ].includes(response.config.url)) {
      //   return res
      // }
      const r = JSON.stringify(res)
      const or = i18n.$t(r)
      return JSON.parse(or)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
